import React from 'react';
import classNames from 'classnames';

import ExpandIcon from '@geobank/assets/src/icons/ExpandIcon';

import styles from './Select.module.scss';

interface SelectProps {
  // children: React.ReactNode[];
  // className?: string;
  // onChange?: (value: string | number | undefined) => void;
  containerProps?: React.HtmlHTMLAttributes<HTMLDivElement>;
}

// interface SelectComponentType
//   extends React.FC<SelectProps & React.SelectHTMLAttributes<HTMLSelectElement>> {
//   Option: typeof SelectOption;
// }

/*
  Переписал на FC.
  Если будет необходимость получать доступ к State или внутренним методам, то для этого лучше подходит PureComponent
*/
const Select: React.FC<SelectProps & React.SelectHTMLAttributes<HTMLSelectElement>> = props => {
  const { children, containerProps, className, ...restProps } = props;
  // вытащить containerProps?.className перед деструктуризацией или className поместить в конец передачи props

  return (
    <div
      {...containerProps}
      className={classNames(styles.selectContainer, containerProps?.className)}
    >
      <select
        className={classNames(styles.selectContent, className)}
        /* onChange={onChange} */ {...restProps}
      >
        {children}
        {/* {React.Children.map(props.children, child => {
          if (!React.isValidElement(child)) {
            return null;
          }
          // <SelectOption>
          if (child.type === SelectOption) {
            return React.cloneElement<SelectOptionProps>(child, {
              ...child.props,
              // selected: true,
            });
          } else {
            return null;
          }
        })} */}
      </select>
      <div className={styles.arrowDownIconContainer}>
        <ExpandIcon fill={'#6AC3FA'} />
      </div>
    </div>
  );
};

// Error then wrap React.memo(Select)
// Property 'Option' does not exist on type NamedExoticComponent
// Select.Option = SelectOption;

// export default Select;
export default React.memo(Select);
